<template>
  <div v-if="input" class="box grid-x">
    <h3 class="cell" v-text="input.title" />
    <p class="cell" v-html="input.text" />
    <div class="cell grid-x align-center">
      <a
        v-if="input.buttonLink"
        :class="input.buttonLink.cssClass"
        :target="input.buttonLink.target"
        class="button medium-7 align-center"
        :href="input.buttonLink.url"
        v-text="input.buttonLink.text"
      />
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent, PropType } from 'vue';
import MessageBox from './interfaces/IMessageBox';

export default defineComponent({
  name: 'MessageBox',
  props: {
    input: {
      type: Object as PropType<MessageBox>,
      default() {
        return undefined;
      }
    }
  }
});
</script>
<style lang="scss" scoped>
@import 'src/styles/all';
.box {
  padding: rem-calc(50px);

  left: rem-calc(665px);
  top: rem-calc(380px);

  background: $active-field-background;

  .button {
    margin: 0;
    height: rem-calc(50px);
  }
}
</style>
